import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            clipRule="evenodd"
            d="M2.14645 2.14645C2.34171 1.95118 2.65829 1.95118 2.85355 2.14645L13.8536 13.1464C14.0488 13.3417 14.0488 13.6583 13.8536 13.8536C13.6583 14.0488 13.3417 14.0488 13.1464 13.8536L11.7837 12.4908C10.6811 13.1313 9.38766 13.5 8.00433 13.5C4.50847 13.5 1.58636 11.1452 0.869995 8.00008C1.22648 6.43481 2.12928 5.06529 3.37725 4.08435L2.14645 2.85355C1.95118 2.65829 1.95118 2.34171 2.14645 2.14645ZM4.0902 4.79731C3.02697 5.60127 2.24583 6.72283 1.90033 8.00007C2.59386 10.5636 5.04239 12.5 8.00433 12.5C9.11253 12.5 10.1489 12.2289 11.0483 11.7554L9.73827 10.4454C9.24786 10.7946 8.64791 11 8 11C6.34315 11 5 9.65685 5 8C5 7.35209 5.2054 6.75214 5.55463 6.26173L4.0902 4.79731ZM6.27691 6.98402L9.01598 9.72309C8.71823 9.89904 8.3709 10 8 10C6.89543 10 6 9.10457 6 8C6 7.6291 6.10096 7.28177 6.27691 6.98402ZM9.98135 8.27425C9.99365 8.18459 10 8.09304 10 8C10 6.89543 9.10457 6 8 6C7.90696 6 7.81541 6.00635 7.72575 6.01865L6.91091 5.2038C7.24852 5.07221 7.61583 5 8 5C9.65685 5 11 6.34315 11 8C11 8.38417 10.9278 8.75148 10.7962 9.08909L9.98135 8.27425ZM14.1084 7.99993C13.8239 9.0515 13.2442 9.99754 12.4548 10.7477L13.1623 11.4552C14.1347 10.525 14.835 9.33351 15.1387 7.99992C14.4223 4.85478 11.5002 2.5 8.00437 2.5C6.886 2.5 5.82636 2.74099 4.87887 3.17176L5.64226 3.93515C6.36982 3.65493 7.16655 3.5 8.00437 3.5C10.9663 3.5 13.4148 5.43635 14.1084 7.99993Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);

export default Icon;
